<template>
  <a-modal :centered="true" :mask-closable="false" :closable="false" :visible="visible" :footer="null" :width="900" :body-style="{'padding':'12px','box-sizing':'border-box','height':'92%','overflow':'auto'}">
    <div slot="title" class="gpws-drawer-title-span">
      <div class="gpws-drawer-close" @click="()=>onModalClose()"><a-icon type="close" style="margin-right: 3px" />关闭</div>
      <span class="gpws-drawer-title">添加我的方剂</span>
      <span></span>
    </div>
    <a-spin :spinning="loading" tip="正在提交医生私有方剂信息....">
      <a-form :form="form" layout="horizontal" style="margin-top: 20px">
        <a-row>
          <a-col>
            <a-form-item :colon="false" label="方剂名称" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
              <a-input v-decorator="['name', {rules: [{ required: true, message: '方剂名称必须填写!' }], initialValue: '' }]"  placeholder="请输入方剂名称"/>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :colon="false" label="方剂证候" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
              <a-input v-decorator="['syndrome', {initialValue: '' }]" placeholder="请输入方剂证候"/>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :colon="false" label="症状描述" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
              <a-textarea v-decorator="['symptom', {rules: [{ required: false, message: '方剂症状描述必须填写!' }], initialValue: '' }]"  placeholder="请输入方剂症状描述"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item :colon="false" label="方剂药品" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" style="margin-bottom: 0px!important;"></a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col offset="1" span="22" style="border: 1px solid #e8e8e8;">
            <a-row>
              <a-col span="24">
                <a-form-item label="搜索药品" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }" style="margin-bottom: 4px;">
                  <a-select v-model="drugs.keyword" show-search :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" placeholder="请输入名称/编码/首拼检索症状." @search="handleDrugsSearch" @change="handleDrugsChange">
                    <a-select-option v-for="item in drugs.searchs" :key="item.id" :value="item.id" :label="item.name">
                      {{item.name}} &nbsp;&nbsp;&nbsp; {{item.formName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="24">
                <a-table size="small" :columns="drugs.columns" rowKey="id" :data-source="drugs.datas" :pagination="false" style="padding:4px;">
                  <a-form-item slot="dosage" slot-scope="text, record" style="margin-bottom: 1px!important;">
                    <a-input-number :step="0.1" :min="0.1" v-model="record.dosage" />
                  </a-form-item>
                  <a-form-item slot="dosageUnit" slot-scope="text, record" style="margin-bottom: 1px!important;">
                    <a-select v-model="record.unit" style="width: 100px;">
                      <a-select-option v-for="(item, index) in record.units" :key="'d-'+record.id+'-'+(index+1)" :value="item.name">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <span slot="drugOperate" slot-scope="text, record, index">
                            <a href="javascript:;" @click="()=>deleteDrugs(index)">删除</a>
                          </span>
                </a-table>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form>
      <div class="button-container">
        <div>
          <a-button icon="save" type="primary" style="float:right; margin-right: 64px;margin-top: 20px;" @click="()=>savePres()">保存</a-button>
        </div>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
export default {
  name: "OwnPresModal",
  data(){
    return {
      visible:false,
      loading : false,
      current:{},
      form: this.$form.createForm(this),
      drugs:{
        keyword:'',
        columns: [{title: '药品名称', dataIndex: 'name', key: 'drugName', customRender:(text, record, index) =>{
            let name = text == undefined || text == null || text == '' ? '-' : text;
            if(undefined != record.alias && null != record.alias && record.alias.length > 0){
              record.alias.forEach(function (e) {
                name = name + '/'+e;
              });
            }
            return name;
          }
        },{title: '规格', dataIndex: 'spec', key: 'spec', width: 100, customRender:(text, record, index) =>{
            return text == undefined || text == null || text == '' ? '-' : text;
          }
        },{title: '剂型', align: 'center', dataIndex: 'formName', key: 'drugform', width: 100, customRender:(text, record, index) =>{
            return text == undefined || text == null || text == '' ? '-' : text;
          }
        },{title: '剂量', align: 'center', key: 'dosage', width: 150, scopedSlots: { customRender: 'dosage'}
        },{title: '剂量单位', key: 'dosageUnit', align: 'center', width: 150, scopedSlots: { customRender: 'dosageUnit'}
        },{title: '操作', align: 'center', key: 'drugOperate', width: 120, scopedSlots: { customRender: 'drugOperate'}
        }],
        searchs:[],
        datas:[]
      },
    }
  },
  mounted() {
    this.current = JSON.parse(localStorage.getItem("curruser"));
  },
  methods:{
    savePres:function (){
      const self=this;

      if(undefined === this.drugs.datas || null === this.drugs.datas || this.drugs.datas.length <= 0){
        this.$message.error({content: '请先设置方剂药品.', duration: 2});
        return;
      }
      this.form.validateFields((err, values) => {
        if(!err){
          //方剂药品
          let drugs =[];
          self.drugs.datas.forEach(function (e) {
            drugs.push({id:e.id, dosage:e.dosage, unit:e.unit});
          });

          let params={ name:values.name, syndrome:values.syndrome, symptom:values.symptom, drugs: drugs };
          self.loading = true;
          self.$axios.post('/api/clinic/pres/own/'+ this.current.organId + '/' + this.current.doctorId + '/add', params).then(function(res){
            self.loading=false;
            if(res.msg.flag == 0){
              self.$message.success({content:'新增医生私有方剂成功', duration: 2});
              self.$emit('clickit');
              self.onModalClose();
            }else {
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(res){
            self.loading = false;
          })
        }
      })
    },
    showOwnPres:function (){
      this.form.resetFields();
      this.drugs.datas=[];
      this.drugs.searchs=[];
      this.visible=true;
    },
    onModalClose:function (){
      this.form.resetFields();
      this.drugs.datas=[];
      this.drugs.searchs=[];
      this.visible=false;
    },
    //检索处方药品
    handleDrugsSearch:function (value) {
      const self = this;
      this.drugs.searchs=[];
      if(undefined != value && null != value && '' != value && value.length > 1){
        //查询方式确定,带顿号
        if(value.indexOf('、') > 0){
          this.$axios.get('/api/clinic/drug/names', {params:{organId:this.current.organId, keyword:value}}).then(function (res) {
            if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
              res.biz.forEach(function (e) {
                let datas = self.drugs.datas.filter(m => {return m.id == e.id;});
                if(undefined == datas || null == datas || datas.length <= 0){
                  self.drugs.datas.push({id:e.id, code:e.code, alias:e.alias, name:e.name, spec:e.spec, formName:e.form,
                    dosage:((undefined != e.dosage && null != e.dosage)?e.dosage.start:''),
                    unit:((undefined != e.dosage && null != e.dosage)?e.dosage.unit.name:''), units:e.units});
                }
              });
            }
          }, function (res) {
          });
        }else{
          this.$axios.get('/api/clinic/drug/search', {params:{organId:this.current.organId, keyword:value}}).then(function (res) {
            if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
              res.biz.forEach(function (e) {
                self.drugs.searchs.push({id:e.id, code:e.code, alias:e.alias, name:e.name, spec:e.spec, formName:e.form,
                  dosage:((undefined != e.dosage && null != e.dosage)?e.dosage.start:''),
                  unit:((undefined != e.dosage && null != e.dosage)?e.dosage.unit.name:''), units:e.units});
              });
            }
          }, function (res) {
          });
        }
      }
    },
    handleDrugsChange:function (value) {
      const self = this;
      if(undefined != value && null != value && '' != value){
        this.drugs.searchs.forEach(function (e) {
          if(e.id == value){
            let datas = self.drugs.datas.filter(m => {return m.id == e.id;});
            if(undefined == datas || null == datas || datas.length <= 0){
              self.drugs.datas.push(e);
            }
          }
        });
        this.drugs.keyword ='';
      }
    },
    deleteDrugs:function (index) {
      let data = new Array();
      Object.assign(data, this.drugs.datas);
      data.splice(index, 1);
      this.drugs.datas = data;
    }
  }
}
</script>

<style scoped>

</style>